import { useSpacePublicZustandStore } from '@/helpers/spacepublicprovider';
import { lang } from '@/helpers/translate';
import dayjs from '@/helpers/dayjs';
import CalendarSelectableStore from './store';
import Icon from '@/core/icon';

const periods = ['', 'AM', 'PM', 'NI'];

function onClickDelete({ dateformat, period }) {
  const dateCurrent = dayjs(dateformat.replace('e', '').replace(/,000$/, ''));

  const periodstore = CalendarSelectableStore.getPeriod();
  const current = CalendarSelectableStore.getDatesPicked();
  // return console.log('period', periodstore, current);
  const index = current.indexOf(dateCurrent.formatAsKey());
  if (index >= 0) {
    const newPeriod = Object.entries(periodstore || {}).reduce((acc, [keydate0, period0]) => {
      if (keydate0 === dateformat && period === period0) return acc;
      acc[keydate0] = period0;
      return acc;
    }, {});
    current.splice(index, 1);

    current.sort((d) => d);
    const df = Object.keys(newPeriod);
    df.sort((d) => dayjs(d));
    const ordered = df.reduce((acc, d) => {
      acc[d] = newPeriod[d];
      return acc;
    }, {});
    CalendarSelectableStore.setDatesPicked(df);
    CalendarSelectableStore.setPeriod(newPeriod);
    useSpacePublicZustandStore.setState({ datesSelected: { ...CalendarSelectableStore.getPeriod() } });
  }
}

const dateToString = function dateToString(dates, locale) {
  if (!dates || !Object.entries(dates).length) return '';
  dayjs.locale(locale);

  let d = null;
  const last = null;

  d = Object.entries(dates).map(([ddd, period]) => {
    const objDate = dayjs(ddd.replace('e', '').replace(/,000$/, ''));
    let strDate = objDate.format('DD MMM ');
    if (period !== 0) strDate += periods[period];
    strDate += objDate.format(' YYYY');
    return { strDate, dateformat: ddd, period };
  });

  return d.map(({ strDate, dateformat, period }) => (
    <div key={`${dateformat}-${period}`} className="first:mt-2 transition flex items-center justify-between w-full col-span-12 px-3.5 py-2 rounded-lg cursor-pointer bg-white hover:bg-white text-purple-5 font-medium">
      {strDate}
      <span onClick={() => { onClickDelete({ dateformat, period }); }}>
        <Icon className="text-purple-5/80 fill-current size-3.5" name="close" />
      </span>
    </div>
  ));
};

export default function DateResume() {
  const currentLang = lang();
  const datesSelected = useSpacePublicZustandStore((state) => state.datesSelected);
  
  if (!datesSelected || typeof datesSelected !== 'object') {
    return null;
  }

  return (<>{dateToString(datesSelected, currentLang)}</>);
}
